// based on example from https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API

let HIDDEN_PROP, VISIBILITY_CHANGE_PROP;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
  HIDDEN_PROP = "hidden";
  VISIBILITY_CHANGE_PROP = "visibilitychange";
} else if (typeof document['msHidden'] !== "undefined") {
  HIDDEN_PROP = "msHidden";
  VISIBILITY_CHANGE_PROP = "msvisibilitychange";
} else if (typeof document['webkitHidden'] !== "undefined") {
  HIDDEN_PROP = "webkitHidden";
  VISIBILITY_CHANGE_PROP = "webkitvisibilitychange";
}

let _nextId:number = 0;
let listeners = {};

export function onVisibilityChange(cb:(visible:boolean)=>void) {
  if (typeof document.addEventListener === "undefined" || HIDDEN_PROP === undefined) {
    console.log("This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
  } else {
    let handler = () => {
      cb(!document[HIDDEN_PROP]);
    };
    cb['onVisibilityChangeHandlerId'] = _nextId++;
    listeners[cb['onVisibilityChangeHandlerId']] = handler;
    console.log('adding event listener for visiblity');
    document.addEventListener(VISIBILITY_CHANGE_PROP, handler);
  }
}

export function offVisibilityChange(cb:(visible:boolean)=>void) {
  if (typeof document.removeEventListener === "undefined" || HIDDEN_PROP === undefined) {
    console.log("This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
  } else {
    let handler = listeners[cb['onVisibilityChangeHandlerId'] || ''];
    if (handler) {
      console.log('removing event listener for visiblity');
      document.removeEventListener(VISIBILITY_CHANGE_PROP, handler);
      delete listeners[cb['onVisibilityChangeHandlerId']];
    }
  }
}
